'use strict';
// Stub required by ycomponent JS loader (load_js=true on faqcategories setting).
// The Vue component (AccordionGroupCategories) is loaded dynamically by the assets loader.
